import FetchData from '@ezviz/FetchData';
import moment from "moment";
import { message } from "antd";
import util from './../../utils/utils';
import intl from 'react-intl-universal';
// 执行构建
export const FETCH_APPLICATION_BUILD_PACKAGE_LOADING = 'FETCH_APPLICATION_BUILD_PACKAGE_LOADING';
export const FETCH_APPLICATION_BUILD_PACKAGE_SUCCESS = 'FETCH_APPLICATION_BUILD_PACKAGE_SUCCESS';
export const FETCH_APPLICATION_BUILD_PACKAGE_FAILED = 'FETCH_APPLICATION_BUILD_PACKAGE_FAILED';

// 查询构建状态
export const FETCH_APPLICATION_BUILD_PACKAGE_STATE_LOADING = 'FETCH_APPLICATION_BUILD_PACKAGE_STATE_LOADING';
// 体验包构建状态查询成功
export const FETCH_APPLICATION_BUILD_PACKAGE_STATE_SUCCESS = 'FETCH_APPLICATION_BUILD_PACKAGE_STATE_SUCCESS';
// 正式包构建状态查询成功
export const FETCH_APPLICATION_BUILD_PACKAGE_STATE_SUCCESS_FORMAL = 'FETCH_APPLICATION_BUILD_PACKAGE_STATE_SUCCESS_FORMAL';
// 查询构建状态接口调用失败
export const FETCH_APPLICATION_BUILD_PACKAGE_STATE_FAILED = 'FETCH_APPLICATION_BUILD_PACKAGE_STATE_FAILED';

export const SET_BUILD_PAGEVIEW = 'SET_BUILD_PAGEVIEW';

// 设置打包超限弹框展示
export const SET_TIPMODAL_VISIBLE = 'SET_TIPMODAL_VISIBLE';

moment.locale("zh-cn");

message.config({
  top: 300,
  maxCount: 3
});

// 查询构建状态
export function fetchApplicationBuildState(param = {}, callback) {
  return (dispatch, getState) => {
    const appId = window.applicationId;
    const {
      packageType = 'experience', // experience 体验包 formal 正式包
    } = param;
    dispatch({
      type: FETCH_APPLICATION_BUILD_PACKAGE_STATE_LOADING,
    });
    const fetchData = new FetchData(`/iot/config/api/iot/support/v1/packages/${appId}/${packageType}`, {
      method: 'GET',
      headers: {
        appId,
      },
      metaHandler: {
        403: () => { window.location.href = '/authrization/login'; return; }
      },
    });
    fetchData
      .then(res => {
        if (res.code == 200) {
          if (res.data) {
            callback && callback();
            const isError = res.data.innerAndroidDownloadUrl.startsWith('fail') ||
              res.data.outterAndroidDownloadUrl.startsWith('fail') ||
              (packageType !== 'experience' && res.data.iosDownloadUrl.startsWith('fail'));

            if (isError) {
              console.log('构建失败')
              if (packageType === 'experience') {
                dispatch({
                  type: FETCH_APPLICATION_BUILD_PACKAGE_STATE_SUCCESS,
                  buildPackageState: 3,
                });
              } else {
                // 正式包构建状态
                dispatch({
                  type: FETCH_APPLICATION_BUILD_PACKAGE_STATE_SUCCESS_FORMAL,
                  buildPackageState: 3,
                });
              }
              return;
            }

            const isBuildDone = !!res.data.innerAndroidDownloadUrl
              && !!res.data.outterAndroidDownloadUrl
              && (packageType === 'experience' || (packageType !== 'experience' && res.data.iosDownloadUrl))
            if (isBuildDone) {
              console.log('构建完成')
              if (packageType === 'experience') {
                dispatch({
                  type: FETCH_APPLICATION_BUILD_PACKAGE_STATE_SUCCESS,
                  buildPackageState: 2,
                  innerAndroidDownloadUrl: res.data.innerAndroidDownloadUrl,
                  outterAndroidDownloadUrl: res.data.outterAndroidDownloadUrl,
                });
              } else {
                dispatch({
                  type: FETCH_APPLICATION_BUILD_PACKAGE_STATE_SUCCESS_FORMAL,
                  buildPackageState: 2,
                  innerAndroidDownloadUrl: res.data.innerAndroidDownloadUrl,
                  outterAndroidDownloadUrl: res.data.outterAndroidDownloadUrl,
                  iosDownloadUrl: res.data.iosDownloadUrl,
                });
              }
            } else {
              console.log('构建进行中');
              if (window.buildState) {
                clearTimeout(window.buildState)
              }
              window.buildState = setTimeout(() => {
                dispatch(fetchApplicationBuildState({ packageType }, callback))
              }, 5000);
              if (packageType === 'experience') {
                dispatch({
                  type: FETCH_APPLICATION_BUILD_PACKAGE_STATE_SUCCESS,
                  buildPackageState: 1,
                });
              } else {
                dispatch({
                  type: FETCH_APPLICATION_BUILD_PACKAGE_STATE_SUCCESS_FORMAL,
                  buildPackageState: 1,
                });
              }
            }
          } else {
            console.log('未构建')
            if (packageType === 'experience') {
              dispatch({
                type: FETCH_APPLICATION_BUILD_PACKAGE_STATE_SUCCESS,
                buildPackageState: 0,
              });
            } else {
              dispatch({
                type: FETCH_APPLICATION_BUILD_PACKAGE_STATE_SUCCESS_FORMAL,
                buildPackageState: 0,
              });
            }
          }
        } else {
          message.error(res.msg || intl.get('commmon.operate.retry'));
          dispatch({
            type: FETCH_APPLICATION_BUILD_PACKAGE_STATE_FAILED,
          });
        }
      })
      .catch(e => {
        message.error(intl.get('commmon.operate.netRetry'));
        dispatch({
          type: FETCH_APPLICATION_BUILD_PACKAGE_STATE_FAILED,
        });
      });
  };
}

// 执行构建
export function fetchApplicationBuildStart(param = {}, callback) {
  return (dispatch, getState) => {
    const appId = window.applicationId;
    const {
      packageType = 'experience', // experience 体验包 formal 正式包
      oemVersion = '1.0.0', // 自定义打包版本 示例：1.2.5.201217  体验版默认此版本，正式包需要用户手动输入版本
    } = param;
    const body = {
      packageType,
      oemVersion,
    }
    dispatch({
      type: FETCH_APPLICATION_BUILD_PACKAGE_LOADING,
    });
    const fetchData = new FetchData('/iot/config/api/iot/support/v1/package', {
      method: 'POST',
      body,
      headers: {
        appId,
      },
      metaHandler: {
        403: () => { window.location.href = '/authrization/login'; return; }
      },
    });
    fetchData
      .then(res => {
        if (res.code == 200) {
          dispatch({
            type: FETCH_APPLICATION_BUILD_PACKAGE_SUCCESS,
          });
          dispatch(fetchApplicationBuildState({ packageType }, () => {
            callback && callback();
          }));
        } else {
          if (res.code == '70007') {
            dispatch(setTipModalVisible({
              tipModalVisible: true,
              tipType: 'day',
            }))
            // 打包天数超限
          } else if (res.code == '70008') {
            // 打包月数超限
            dispatch(setTipModalVisible({
              tipModalVisible: true,
              tipType: 'month',
            }))
          } else {
            message.error(res.msg || intl.get('commmon.operate.retry'));
          }
          dispatch({
            type: FETCH_APPLICATION_BUILD_PACKAGE_FAILED,
          });
        }
      })
      .catch(e => {
        message.error(intl.get('commmon.operate.netRetry'));
        dispatch({
          type: FETCH_APPLICATION_BUILD_PACKAGE_FAILED,
        });
      });
  };
}

// 设置输入版本Modal显示
export function setPageView(pageView) {
  return (dispatch, getState) => {
    dispatch({
      type: SET_BUILD_PAGEVIEW,
      pageView,
    });
  };
}

// 设置打包超限弹框展示
export function setTipModalVisible(data) {
  return (dispatch, getState) => {

    dispatch({
      type: SET_TIPMODAL_VISIBLE,
      tipModalVisible: data.tipModalVisible,
      tipType: data.tipType,
    })
  };
}
